import { defineStore } from 'pinia';

export const useCartStore = defineStore('cart', {
  state: () => ({
    items: [],
    isOpen: false,
    couponCode: null,
    discount: 0,
  }),

  getters: {
    getItems: (state) => state.items,
    getItemCount: (state) =>
      state.items.reduce((total, item) => total + item.quantity, 0),
    getSubtotal: (state) =>
      state.items.reduce((total, item) => total + item.price * item.quantity, 0),
    getDiscount: (state) => state.discount,
    getTotal: (state) => {
      const sub = state.items.reduce((t, i) => t + i.price * i.quantity, 0);
      return Math.max(0, sub - state.discount);
    },
    isCartOpen:  (state) => state.isOpen,
    isInCart:    (state) => (id) => state.items.some((i) => i.id === id),
    getItemById: (state) => (id) => state.items.find((i) => i.id === id) || null,
    isEmpty:     (state) => state.items.length === 0,
  },

  actions: {
    addItem(product) {
      const existing = this.items.find((i) => i.id === product.id);
      if (existing) {
        existing.quantity += product.quantity || 1;
      } else {
        this.items.push({
          id:       product.id,
          name:     product.name,
          price:    product.price,
          image:    product.image  || null,
          quantity: product.quantity || 1,
          sku:      product.sku    || null,
        });
      }
      this._persist();
    },

    removeItem(productId) {
      this.items = this.items.filter((i) => i.id !== productId);
      this._persist();
    },

    incrementItem(productId) {
      const item = this.items.find((i) => i.id === productId);
      if (item) { item.quantity++; this._persist(); }
    },

    decrementItem(productId) {
      const item = this.items.find((i) => i.id === productId);
      if (!item) return;
      item.quantity <= 1 ? this.removeItem(productId) : (item.quantity--, this._persist());
    },

    applyCoupon(code, amount) { this.couponCode = code; this.discount = amount; this._persist(); },
    removeCoupon()             { this.couponCode = null; this.discount = 0;      this._persist(); },

    clearCart() {
      this.items = []; this.couponCode = null; this.discount = 0;
      this._persist();
    },

    openCart()   { this.isOpen = true;  },
    closeCart()  { this.isOpen = false; },
    toggleCart() { this.isOpen = !this.isOpen; },

    init() {
      try {
        const s = localStorage.getItem('cart_v1');
        if (s) { const p = JSON.parse(s); this.items = p.items||[]; this.couponCode = p.couponCode||null; this.discount = p.discount||0; }
      } catch(e) { console.warn('Cart restore failed', e); }
    },

    _persist() {
      try { localStorage.setItem('cart_v1', JSON.stringify({ items: this.items, couponCode: this.couponCode, discount: this.discount })); }
      catch(e) { console.warn('Cart persist failed', e); }
    },

    $reset() { this.clearCart(); this.isOpen = false; },
  },
});